import React, { Component } from 'react'

import EditableLabel from '../common/EditableLabel'
import ElementContainer from '../common/ElementContainer'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

import './DateTime.css'
import moment from 'moment-timezone'

export default class DateTime extends Component {
  static weight = 1

  static defaultConfig = {
    id: 0,
    type: 'DateTime',
    label: 'Date Time'
  }

  static metaData = {
    icon: faCalendar,
    displayText: 'Date Time',
    group: 'inputElement'
  }

  static configurableSettings = {
    dtStart: {
      default: '',
      formProps: {
        type: 'Checkbox',
        options: ['Is date start']
      }
    },
    dtEnd: {
      default: '',
      formProps: {
        type: 'Checkbox',
        options: ['Is date end']
      }
    }
  }

  static submissionHandler = {
    findQuestionValue: (inputs, qid) => {
      let value = ''
      for (const elem of inputs) {
        if (elem.q_id === qid && elem.value) {
          value = moment.tz(elem.value, 'Europe/Paris').toISOString()
        }
      }
      return value
    }
  }

  static getPlainStringValue(entry) {
    let plainString

    if (entry.value !== '') {
      plainString = entry.value
    } else {
      plainString = '-'
    }

    return plainString
  }

  static renderDataValue(entry) {
    return entry.value ? entry.value : '-'
  }

  static helpers = {
    getElementValue: 'defaultInputHelpers',
    isFilled: 'defaultInputHelpers'
  }
  render() {
    const { config, mode } = this.props
    const inputProps = {}

    if (typeof config.value !== 'undefined') {
      inputProps.value = config.value
    }

    if (typeof config.defaultValue !== 'undefined') {
      inputProps.defaultValue = config.defaultValue
    }

    if (typeof this.props.onChange !== 'undefined') {
      inputProps.onChange = this.props.onChange
    }

    if (typeof config.placeholder !== 'undefined') {
      inputProps.placeholder = config.placeholder
    }

    if (typeof config.maxLength !== 'undefined') {
      inputProps.maxLength = config.maxLength
    }

    return (
      <ElementContainer type={config.type} {...this.props}>
        <div className="elemLabelTitle">
          <EditableLabel
            className="fl label"
            dataPlaceholder="Type a question"
            mode={mode}
            labelKey={config.id}
            handleLabelChange={this.props.handleLabelChange}
            value={config.label}
            required={config.required}
          />
        </div>
        <div className="fl input">
          <input
            id={`q_${config.id}`}
            name={`q_${config.id}`}
            type="datetime-local"
            {...inputProps}
          />
        </div>
        {mode === 'viewer' ? (
          ''
        ) : (
          <div className="clearfix">
            <EditableLabel
              className="sublabel"
              dataPlaceholder="Click to edit sublabel"
              mode={mode}
              labelKey={`sub_${config.id}`}
              handleLabelChange={this.props.handleLabelChange}
              value={
                typeof config.sublabelText !== 'undefined' &&
                config.sublabelText !== ''
                  ? config.sublabelText
                  : ''
              }
            />
          </div>
        )}
        <div className="fl metadata">
          <div className="requiredErrorText">{config.requiredText}</div>
        </div>
      </ElementContainer>
    )
  }
}
